import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const heygen = defineConnector({
  identifier: "heygen",
  name: "HeyGen",
  tagLine: "AI video generation",
  logo,
  protocol: "http",
  tags: ["ai", "productivity"],
  defaultUrlPattern: () => "https://api2\\.heygen\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a HeyGen app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to your [HeyGen settings](https://app.heygen.com/settings) and navigate to the **API** section to create a new OAuth application.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/heygen/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your HeyGen account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your HeyGen account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://app.heygen.com/oauth/authorize",
    tokenEndpoint: () => "https://api2.heygen.com/v1/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api2.heygen.com/v2/user/remaining_quota",
  },
});
